import { render, staticRenderFns } from "./cModalUnidad.vue?vue&type=template&id=5a378452&scoped=true"
import script from "./cModalUnidad.vue?vue&type=script&lang=js"
export * from "./cModalUnidad.vue?vue&type=script&lang=js"
import style0 from "./cModalUnidad.vue?vue&type=style&index=0&id=5a378452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a378452",
  null
  
)

export default component.exports